import { adapter } from "@hg/adapt-sdk"

adapter.init({
    extraParams: [
        {
            key: "invite_code",
            convertTo: "string",
        },
        {
            key: "page",
            convertTo: "string",
        },
        {
            key: "auth",
            convertTo: "string",
        },
        {
            key: "channel",
            convertTo: "string",
        },
    ],
})

export const getPage = () => String(adapter.getExtraParams().page || "")
export const getWebViewAuth = () => String(adapter.getExtraParams().auth || "")
export const getWebViewChannel = () => String(adapter.getExtraParams().channel || "")

export { adapter }

const emptyFn = () => {}

export const mockSdk = {
    ETL: {
        event: emptyFn,
        instance: { setPageProperties: emptyFn },
    },
    Share: { setShareInfo: emptyFn },
    socialShare: {
        setGlobalConfig: emptyFn,
        getAvailableChannels: async () => [],
        shareSiteTo: async () => true,
        utils: {
            generateQRCode: async () =>
                "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==",
        },
    },
}

const sdkMockReady: {
    (cb: (sdk: typeof mockSdk) => void): Promise<typeof mockSdk>
    (): Promise<typeof mockSdk>
} = async (cb?: (sdk: typeof mockSdk) => void) => {
    if (cb) cb(mockSdk)
    return mockSdk
}

export const sdkReady = sdkMockReady

export async function collect(
    _event: string,
    _properties?: Record<string, unknown>,
) {
    return
}
